// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-window {
  position: fixed;
  background-color: rgba(250, 248, 245, 0.9);
  border-radius: 12px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.06);
  width: 250px;
  z-index: 1000;
  -webkit-user-select: none;
          user-select: none;
}

.settings-window-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(135, 134, 127, 0.25);
  cursor: grab;
  position: relative;
}

.settings-window-header:active {
  cursor: grabbing;
}

/* Update close button styling */
.close-button {
  position: absolute;
  right: 8px;
  top: 30%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #454545;
  border-radius: 4px;
}

.settings-window-content {
  padding: 16px;
}

.settings-section {
  margin-bottom: 4px;
}

.settings-section:last-child {
  margin-bottom: 0;
}

.image-upload {
  margin-top: 8px;
  width: 100%;
}

.image-preview {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}

.image-preview img {
  border: 2px solid #D3AF37;
}

.settings-window .theme-button {
  margin-top: 4px;
  background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));
  border: 1px solid rgba(135, 134, 127, 0.25);
}

.settings-window .theme-button:hover {
  border-color: rgba(135, 134, 127, 0.5);
  transform: translateY(-1px);
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Table/SettingsWindow.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gDAAgD;EAChD,YAAY;EACZ,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kDAAkD;EAClD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qEAAqE;EACrE,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B","sourcesContent":[".settings-window {\n  position: fixed;\n  background-color: rgba(250, 248, 245, 0.9);\n  border-radius: 12px;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.06);\n  width: 250px;\n  z-index: 1000;\n  user-select: none;\n}\n\n.settings-window-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(135, 134, 127, 0.25);\n  cursor: grab;\n  position: relative;\n}\n\n.settings-window-header:active {\n  cursor: grabbing;\n}\n\n/* Update close button styling */\n.close-button {\n  position: absolute;\n  right: 8px;\n  top: 30%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 4px;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #454545;\n  border-radius: 4px;\n}\n\n.settings-window-content {\n  padding: 16px;\n}\n\n.settings-section {\n  margin-bottom: 4px;\n}\n\n.settings-section:last-child {\n  margin-bottom: 0;\n}\n\n.image-upload {\n  margin-top: 8px;\n  width: 100%;\n}\n\n.image-preview {\n  margin-top: 12px;\n  display: flex;\n  justify-content: center;\n}\n\n.image-preview img {\n  border: 2px solid #D3AF37;\n}\n\n.settings-window .theme-button {\n  margin-top: 4px;\n  background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));\n  border: 1px solid rgba(135, 134, 127, 0.25);\n}\n\n.settings-window .theme-button:hover {\n  border-color: rgba(135, 134, 127, 0.5);\n  transform: translateY(-1px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
